// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HasSeen":"cn_a bhs_fm bhs_vv bhs_xg bhs_h"};